import { Media as API } from '@src/api/types';
import { baseURL } from '@src/configuration/constants';
import { Media as Data } from '@src/types';

const Factory = (api: API): Data => {
  if (api === null) {
    return {
      type: 'UNKNOWN',
      source: {
        uri: '',
      },
    };
  }
  switch (api.mediaType) {
    case 'AUDIO':
      return {
        type: 'AUDIO',
        source: {
          uri: `${baseURL}/media/v1/audio/${api.mediaName}`,
        },
      };
    case 'PHOTO':
      return {
        type: 'PHOTO',
        source: {
          uri: `${baseURL}/media/v1/image/${api.mediaName}`,
        },
        height: api.mediaSize?.height,
        width: api.mediaSize?.width,
      };
    case 'VIDEO':
      return {
        type: 'VIDEO',
        source: {
          uri: `${baseURL}/media/v1/video/stream/${api.mediaName}`,
        },
        thumbnail: {
          uri: `${baseURL}/media/v1/image/${api.thumbnail}`,
        },
        height: api.mediaSize?.height,
        width: api.mediaSize?.width,
      };
    default:
      return {
        type: 'UNKNOWN',
        source: {
          uri: '',
        },
      };
  }
};

export default Factory;
